import createHeartComponent, {
    type SaveAdProps,
} from '@finn-no/favorite-heart-component';
import React from 'react';
import { useAppConfig } from '../../AppConfig';

type FavoriteHeart = ReturnType<typeof createHeartComponent>;

const FavoriteHeartContext = React.createContext<FavoriteHeart | null>(null);

type FavoriteHeartProviderProps = {
    children: React.ReactNode;
};

export function FavoriteHeartProvider(props: FavoriteHeartProviderProps) {
    const { children } = props;
    const { favoriteUrl, loginId } = useAppConfig();

    const Heart = createHeartComponent({
        baseUri: favoriteUrl,
        renderServerSide: true,
        userId: loginId,
    });

    return (
        <FavoriteHeartContext.Provider value={Heart}>
            {children}
        </FavoriteHeartContext.Provider>
    );
}

type FavoriteHeartProps = Omit<
    SaveAdProps,
    'isMobile' | 'itemId' | 'itemType' | 'locale'
> & {
    itemId: string;
};

export function FavoriteHeart(props: FavoriteHeartProps) {
    const { itemId, ...passThroughProps } = props;

    const { isProbablyMobile, locale } = useAppConfig();

    const Heart = React.useContext(FavoriteHeartContext);

    if (typeof Heart === 'undefined') {
        throw new Error(
            'FavoriteHeart must be used within an FavoriteHeartProvider',
        );
    }

    return Heart ? (
        <Heart
            isMobile={isProbablyMobile}
            itemId={itemId as unknown as number}
            itemType="Ad"
            locale={locale}
            {...passThroughProps}
        />
    ) : null;
}
